import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main'
import index from '@/components/pages/index'
import ai from '@/components/pages/ai'
import design from '@/components/pages/design'
import selfmedia from '@/components/pages/selfmedia'
import programmer from '@/components/pages/programmer'
import student from '@/components/pages/student'
import operation from '@/components/pages/operation'
import officework from '@/components/pages/officework'
import business from '@/components/pages/business'



import biaoqianlist from '@/components/pages/biaoqianlist'
import labellist from '@/components/pages/labellist'
import labeldetails from '@/components/pages/labeldetails'
import contact from '@/components/pages/contact'
import role from '@/components/pages/role'
import rolelist from '@/components/pages/rolelist'
import anliyixia from '@/components/pages/anliyixia'
import anliyixiadetails from '@/components/pages/anliyixiadetails'
import yiwan from '@/components/pages/yiwan'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/main/index'
    },
    {
      path: '/main/',   
      component: main,
      children: [      
        // 首页
        { path: 'index', name: 'index', component: index},
        { path: 'ai', name: 'ai', component: ai},
        { path: 'design', name: 'design', component: design},
        { path: 'selfmedia', name: 'selfmedia', component: selfmedia},
        { path: 'programmer', name: 'programmer', component: programmer},
        { path: 'student', name: 'student', component: student},
        { path: 'officework', name: 'officework', component: officework},
        { path: 'business', name: 'business', component: business},
        { path: 'operation', name: 'operation', component: operation},
        { path: 'biaoqianlist', name: 'biaoqianlist', component: biaoqianlist},
        { path: 'labellist', name: 'labellist', component: labellist},
        { path: 'labeldetails', name: 'labeldetails', component: labeldetails},
        { path: 'contact', name: 'contact', component: contact},
        { path: 'role', name: 'role', component: role},
        { path: 'rolelist', name: 'rolelist', component: rolelist},
        { path: 'anliyixia', name: 'anliyixia', component: anliyixia},
        { path: 'anliyixiadetails', name: 'anliyixiadetails', component: anliyixiadetails},
        { path: 'yiwan', name: 'yiwan', component: yiwan},
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js